import { render, staticRenderFns } from "./FunctionSetting.vue?vue&type=template&id=9e31f1ea&scoped=true"
import script from "./FunctionSetting.vue?vue&type=script&lang=js"
export * from "./FunctionSetting.vue?vue&type=script&lang=js"
import style0 from "./FunctionSetting.vue?vue&type=style&index=0&id=9e31f1ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e31f1ea",
  null
  
)

export default component.exports